<script>
/*
 * 打包时去掉 html页面引入地址
 */
import 'tailwindcss/tailwind.css'
import Vue from 'vue'
import { Button,Form,Checkbox,Field,Toast, Image} from 'vant'
import 'vant/lib/index.css'
import Cookies from 'js-cookie'
import pcInterface from '@/H5components/utils/base'
import jsonp from 'jsonp'
Vue.use(Button)
Vue.use(Form)
Vue.use(Checkbox)
Vue.use(Field)
Vue.use(Toast)
Vue.use(Image)
const secret = new pcInterface.pcUtils.optPassword() //加密手机号
console.log('22234', process.env.NODE_ENV)
const apiHost =
  process.env.NODE_ENV == 'production' ? '//my.leju.com' : '//my.bch.leju.com'
export default Vue.extend({
  name: 'Login',
  zhName: '登录组件',
  props: {
    title: { type: String, default: '预约看房' },
    btnText: { type: String, default: '提交' }
  },
  data() {
    return {
      checked: true,
      state: {
        mobile: '',
        imageCode: '',
        code: ''
      },
      smsCode: {
        text: '获取验证码',
        cd: 60,
        timer: null
      },
      imgcode: '',
      showLoginDialog: false
    }
  },
  mounted() {
    this.changeImgCode()
  },
  methods: {
    showLoginDialogFn() {
      this.showLoginDialog = true
    },
    //是否登录
    isLogin() {
      return Cookies.get('M_UID') ? true : false
    },
    //cookie信息
    getInfo() {
      return Cookies.get('M_UID')
    },
    //h5跳转
    jumpH5(src) {
      window.location.href = src
    },
    //复选框
    handleCheckBox() {
      this.checked = !this.checked
    },
    //关闭dialog
    closeLzDialog() {
      this.showLoginDialog = false
    },
    handleLogin() {
      console.log('222', this.checked)
      if (!this.checked) {
        Toast('请同意服务协议')
        return
      }
      jsonp(
        `${apiHost}/web/sso/ssoLogin?`,
        {
          param: `mobile=${secret.secretMethod(this.state.mobile)}&code=${
            this.state.code
          }&key= YmNjYWQxZjRiUzVzWldwMUxtTnZiUT09YmVjZA==&callback`,
          name: 'callback'
        },
        (err, data) => {
          if (err) {
            reject(err)
          } else {
            if (data.code == 0) {
              Toast(data.msg)
              setTimeout(() => {
                this.showLoginDialog = false
              }, 2000)
              this.callback(data)
            } else {
              Toast(data.msg)
            }
          }
        }
      )
    },
    //图片验证码src图片
    changeImgCode() {
      this.imgcode = `${apiHost}/Settings/Findpwd/chengCode?${Date.now()}`
    },
    handleSendCode() {
      if (this.smsCode.timer) return
      jsonp(
        `${apiHost}/Settings/Findpwd/checkImageCode?`,
        {
          param: `mobile=${this.state.mobile}&imageCode=${this.state.imageCode}&callback`,
          name: 'callback'
        },
        (err, data) => {
          console.log('图片验证码接口', err, data)
          if (err) {
            this.state.imageCode = ''
            this.changeImgCode()
          } else {
            if (data.code == 0) {
              jsonp(
                `${apiHost}/web/sso/ssoSendCode?`,
                {
                  param: `mobile=${secret.secretMethod(
                    this.state.mobile
                  )}&codetype=0&callback`,
                  name: 'callback'
                },
                (err, data) => {
                  if (err) {
                    Toast(data.msg)
                  } else {
                    if (data.code == 0) {
                      Toast(data.msg)
                      this.setTimer()
                    } else {
                      Toast(data.msg)
                    }
                  }
                }
              )
            } else {
              Toast(data.msg) //图片验证码输入错误
              this.state.imageCode = ''
              this.changeImgCode()
            }
          }
        }
      )
    },
    //
    setTimer() {
      const end = Date.now() + Number(this.smsCode.cd) * 1000

      this.smsCode.timer = setInterval(() => {
        const now = Date.now()
        this.smsCode.text = `${Math.ceil((end - now) / 1000)}s`

        if (now >= end) {
          clearInterval(Number(this.smsCode.timer))
          this.smsCode.text = '获取验证码'
          this.smsCode.timer = null
        }
      }, 250)
    },
    //电话验证
    telValidator(val) {
      if (val == '') {
        Toast({ message: '请输入手机号' })
        return false
      } else if (!this.isMobile(val)) {
        Toast('手机号格式错误')
        return false
      } else {
        return true
      }
    },
    //手机号正则表达式
    isMobile(phone) {
      const regExp = new RegExp('^1[0123456789]\\d{9}$')
      return regExp.test(phone)
    },
    //图片验证码
    imageCodeValidator(val) {
      if (!val) {
        Toast({ message: '请填写图片验证码' })
        return false
      }
      return true
    },
    //短信验证码
    codeValidator(val) {
      if (!val) {
        Toast({ message: '请填写短信验证码' })
        return false
      }
      return true
    }
  }
})
</script>
<template>
  <!-- 登录表单 -->
  <div class="mask-layer" v-show="showLoginDialog">
    <div class="mask-w w-full">
      <div class="mask-warp w-80">
        <div class="mask-title">{{ title }}</div>
        <div class="lz-warp">
          <van-form
            :show-error-message="false"
            :show-error="false"
            class="w-full"
          >
            <template>
              <div class="lz-li">
                <van-field
                  placeholder="请输入您的手机号码"
                  name="telValidator"
                  v-model="state.mobile"
                  :rules="[
                    {
                      validator: telValidator,
                      message: '手机号格式错误',
                      trigger: 'onBlur'
                    }
                  ]"
                />
              </div>
              <div class="lz-li">
                <van-field
                  v-model="state.imageCode"
                  placeholder="请输入图片验证码"
                  name="imageCodeValidator"
                  :rules="[
                    {
                      validator: imageCodeValidator,
                      message: '请输入图片验证码',
                      trigger: 'onSubmit'
                    }
                  ]"
                />
                <van-image
                  class="code-img"
                  :src="imgcode"
                  @click="changeImgCode"
                />
              </div>
              <div class="lz-li">
                <van-field
                  v-model="state.code"
                  placeholder="请输入短信验证码"
                  name="codeValidator"
                  :rules="[
                    {
                      validator: codeValidator,
                      message: '请输入短信验证码',
                      trigger: 'onSubmit'
                    }
                  ]"
                />
                <div
                  class="send-msg"
                  @click="handleSendCode"
                  :disabled="smsCode.timer ? true : false"
                >
                  {{ smsCode.text }}
                </div>
              </div>
              <div class="agreement-warp ">
                <div class="aw-checkbox">
                  <van-checkbox
                    shape="square"
                    icon-size="12"
                    v-model="checked"
                    checked-color="#ee0a24"
                  ></van-checkbox>
                </div>
                <div class="ag-txt">
                  <span @click="handleCheckBox">我已阅读并同意</span
                  ><span
                    class="agt1"
                    @click="jumpH5('https://my.leju.com/Web/sso/protocol')"
                    >《服务协议》</span
                  >和<span
                    class="agt1"
                    @click="jumpH5('https://my.leju.com/Web/sso/mfprotocol')"
                    >《隐私政策》</span
                  ><span>免登录体验，未注册将自动创建乐居账号</span>
                </div>
              </div>
            </template>
            <div class="lz-btn-warp">
              <van-button class="btn" native-type="button"  @click="closeLzDialog">取消</van-button>
              <van-button
                class="btn btn1"
                native-type="submit"
                @click="handleLogin"
                >{{ btnText }}</van-button
              >
            </div>
          </van-form>
        </div>
      </div>
      <div class="hf-close mask-closed" @click="closeLzDialog"></div>
    </div>
  </div>
</template>
<style lang="scss">
*, ::before, ::after {
  box-sizing: content-box;
}
</style>
<style lang="scss" scoped>
.mask-layer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  background: rgba(0, 0, 0, 0.5);
  .mask-warp {
    display: flex;
    flex-direction: column;
    align-items: center;
    // width: 310px;
    background: linear-gradient(180deg, #ffffff 0%, #ffffff 100%);
    border-radius: 16px;
    border: 3px solid #f84064;
    .mask-title {
      display: flex;
      justify-content: center;
      margin-bottom: 22px;
      width: 261px;
      height: 45px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #76413a;
      line-height: 34px;
      background: url(//ess.leju.com/common/photo/2-1-71SD4Pzi3xYaGPs2qu8ZWZ2xXXLUTJUkYd0EJ6VCl8HLkzOhnnSHdGQSiOlUby1mUJPBKxy4NQAD5ruf.png)
        no-repeat;
      background-size: 100% 100%;
    }
  }
  .agreement-warp {
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;
    margin-top: 8px;
    color: #7d8084;
    line-height: 17px;
    // font-size: 12px;
    .aw-checkbox {
      margin-top: 6px;
      margin-right: 4px;
    }
    .ag-txt {
      font-size: 12px;
    }
    .agt1 {
      color: #7994c3;
    }
  }
  .lz-btn-warp {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
    .btn {
      width: 94px;
      height: 34px;
      line-height: 34px;
      background: #ebeff7;
      border-radius: 25px;
      color: #7d8084;
      border: 0px;
    }
    .btn1 {
      background: #d9172a;
      margin-left: 16px;
      color: #ffffff;
    }
  }
  .mask-w {
    position: absolute;
    display: flex;
    align-items: center;
    flex-direction: column;
    align-items: center;
    z-index: 15;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
  .mask-closed {
    margin-top: 20px;
    width:30px;
    height:30px;
    background: url(//ess.leju.com/common/photo/2-1-iIIZLdVkPIlXLhZGjRHnLRN6tGdHAyRfKK5Apdk6iYbsT8xscLNIAplak5XVfyPiWpfWOXDbA4W7paSL.png)
      no-repeat;
    background-size: 100% 100%;
  }
}
.agreement-warp {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  color: #7d8084;
  line-height: 17px;
  font-size: 12px;
  .agt1 {
    color: #7994c3;
  }

  :deep(.van-icon) {
    border-color: #d9172a;
  }
}
:deep .van-field__control::-webkit-input-placeholder {
  color: #757778;
  font-size: 14px;
}
:deep(.van-field__control) {
  height: 42px;
  width: 262px;
  line-height: 42px;
  padding-left: 4px;
}
:deep(.van-field) {
  border-bottom: 1px solid #edeef2;
}
:deep(.van-cell) {
  padding: unset !important;
  &::after {
    display: none;
  }
}
.lz-warp {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 21px;
  margin-right: 21px;

  .lz-li {
    position: relative;
  }
  .send-msg {
    position: absolute;
    height: 16px;
    font-size: 11px;
    text-align: center;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #7994c3;
    line-height: 16px;
    right: 7px;
    top: 13px;
  }
  .code-img {
    position: absolute;
    width: 66px;
    height: 28px;
    right: 0;
    top: 7px;
    z-index: 10;
  }
}
.lz-warp-background {
  border-radius: 0 0 16px 16px;
  background-image: url(https://ess.leju.com/common/photo/2-1-QSzJrALxl7i40YRcmn1bLcxr8nNKrAZXZLzfGXVjmDromMPAdoFTLiT87gxQakpP7hC44kud5aWvBUcO.png);
}
</style>
